import React from "react";
import { toast } from "react-toastify"; 

export default function Final({ nextStep, prevStep }) {
  const handleFinish = () => {
    toast.success(" You have completed all steps successfully!", {
      position: "top-center",
      autoClose: 2000,
    });

  };

  return (
    <>
      <div className="form-navigator-body">
        <div className="row m-3">
          <ol>
            <li>This report will be prepared by the DPM/CPM and submitted to SACS with a copy to DTO/DACO. It should be compiled on monthly reports revieved from facilities, meetings at district/state level and field visits by DISHA staff.</li>
            <li>Any DISHA staff including officials from SACS or DACO/DTO visiting the same facilitiy in a month, it will be counted only one visit. (Number of Facilities visited, not the total visits)
(NACP facilities should be visited at least 1/3rd of the facilities in the month so that all the facilities are visited in a quarter)</li>
            <li>Last date of submission of report: on or before 7th day of every month to the SACS </li>
          </ol>
        </div>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={handleFinish} className="btn btn-dark border-0">
          Finish
        </button>
      </div>
    </>
  );
}
